import { createReducer, Action, on } from '@ngrx/store';
import {
  createFormGroupState,
  onNgrxForms,
  updateGroup,
  validate,
  onNgrxFormsAction,
  SetValueAction,
  wrapReducerWithFormStateUpdate,
  setValue,
} from 'ngrx-forms';
import {
  email,
  required,
} from 'ngrx-forms/validation';
import { IInitialDataState, InitialDataModel } from './state';
import { CreateLeadResponseAction, ResetDataSavedAction, SetDataFromDetailsStepAction } from './actions';

const formName = 'initialData';

const defaultState: IInitialDataState = {
  form: createFormGroupState(formName, new InitialDataModel()),
  dataSaved: false
};

const validateInitialData = updateGroup<InitialDataModel>({
  firstName: validate(required),
  lastName: validate(required),
  email: validate(required, email),
});


const reducer = createReducer(
  defaultState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, _action) => {
    return state;
  }),
  on(CreateLeadResponseAction, (state) => {
    return {
      ...state,
      dataSaved: true
    }
  }),
  on(SetDataFromDetailsStepAction, (state, { data }) => {
    return {
      ...state,
      form: updateGroup<InitialDataModel>(state.form, { firstName: setValue(data.firstName), lastName: setValue(data.lastName) })
    }
  }),
  on(ResetDataSavedAction, (state) => {
    return {
      ...state,
      dataSaved: false
    }
  })
);

const editInitialDataFormState = wrapReducerWithFormStateUpdate(
  reducer,
  s => s.form,
  validateInitialData
)

export function initialDataReducer(state: any | undefined, action: Action) {
  return editInitialDataFormState(state, action);
}
